import { render, staticRenderFns } from "./CarouselManage.vue?vue&type=template&id=3634a1d4&scoped=true"
import script from "./CarouselManage.vue?vue&type=script&lang=js"
export * from "./CarouselManage.vue?vue&type=script&lang=js"
import style0 from "./CarouselManage.vue?vue&type=style&index=0&id=3634a1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3634a1d4",
  null
  
)

export default component.exports